export const quickLinks = [
  {
    title: "Our Team",
    url: "/our-team",
  },
  {
    title: "About Us",
    url: "/about-us",
  },
  {
    title: "Contact Us",
    url: "/contact-us",
  },
  {
    title: "Money Transfer",
    url: "#",
  },
  {
    title: "FAQs",
    url: "/faqs",
  },
];

export const legal = [
  {
    title: "Privacy Policy",
    url: "/privacy-policy",
  },
  {
    title: "Terms and conditions",
    url: "/terms",
  },
  {
    title: "TML Policy",
    url: "/tml-policy",
  },
  {
    title: "Complaints procedure",
    url: "/complaints",
  },
  {
    title: "Cookie Policy",
    url: "/cookies",
  },
];
